export interface FontRightApp {
    apps: number | null;
    years: number | null;
}

export interface FontRightDesktop {
    computers: number | null;
}

export interface FontRightEPub {
    ebooks: number | null;
}

export interface FontRightWeb {
    visits: number | null;
    views: number | null;
    years: number | null;
}

export interface FontRights {
    app?: FontRightApp;
    desktop?: FontRightDesktop;
    epub?: FontRightEPub;
    web?: FontRightWeb;
}

export const EMPTY_FONT_RIGHTS: FontRights = {
    app: {
        apps: null,
        years: null,
    },
    desktop: {
        computers: null,
    },
    epub: {
        ebooks: null,
    },
    web: {
        visits: null,
        views: null,
        years: null,
    },
};
